import { render, staticRenderFns } from "./Refinement.vue?vue&type=template&id=148bf3ce&"
import script from "./Refinement.vue?vue&type=script&lang=js&"
export * from "./Refinement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/www/finda/current/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('148bf3ce')) {
      api.createRecord('148bf3ce', component.options)
    } else {
      api.reload('148bf3ce', component.options)
    }
    module.hot.accept("./Refinement.vue?vue&type=template&id=148bf3ce&", function () {
      api.rerender('148bf3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "buysearchsell/vue/components/Refinement.vue"
export default component.exports